
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardBody>
              <CRow>
                <CCol sm="10">
                </CCol>
                <CCol sm="2">
                  <CSelect
                    label="都道府県"
                    :options="region"
                    v-model="select_place"
                    @update:value="search"
                    name="region"
                  />
                </CCol>
              </CRow>


              <CDataTable
                :hover="true"
                :striped="true"
                :items="examinations"
                :fields="fields"
                :loading="isLoading"
                :itemsPerPage="40"
                :responsive="true"
                :tableFilter="true"
                @update:table-filter-value="search"
                sorter
                @update:sorter-value="sort"
              >
                <template #industry_id="{item}">
                  <td> {{ industries[item.industry_id] }}</td>
                </template>
                <template #date="{item}">
                  <td>
                    <CLink :href="'/examination/' + item.id"> {{ formatDate(item.date) }}</CLink>
                  </td>
                </template>
                <template #region="{item}">
                    <td v-if='item.region != undefined'> {{ item.region }}</td>
                    <td v-else></td>
                </template>
                <template #address="{item}">
                    <div v-if='item.place_ids != undefined'>
                      <td>{{ getPlace(item.place_ids)}}</td>
                    </div>
                    <td v-else>
                      {{ item.place_name }}
                    </td>
                </template>
                <template #announce_date="{item}">
                  <td> {{formatDate(item.announce_date)}}</td>
                </template>
              </CDataTable>
              <CPagination
                :activePage.sync="page"
                :pages="meta.total_pages"
                align="center"
                @update:activePage="updatePageData"
              />
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
     <CRow>
      <CCol sm="6">
        <CCard>
          <CCardHeader>
            <CIcon name="cil-grid"/> 学習用テキスト
          </CCardHeader>
          <CCardBody>
            <div v-for='studyText in studyTextList' :key='studyText["link"]'>
              <div v-if='industry_id == studyText["industry_id"]'>
                <a v-if='studyText["title"] != ""' target="_blank" :href="studyText.link" class="mgr-20">{{ studyText['small_industry'] }} {{studyText['title']}}</a>
                <a v-else target="_blank" :href="studyText.link" class="mgr-20">{{ studyText['small_industry'] }} 学習用テキスト</a>
              </div>
            </div>
             <p v-if='studyTextList.length == 0'>
              データがありません
            </p>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="6">
        <CCard>
          <CCardHeader>
            <CIcon name="cil-grid"/> 過去問題
          </CCardHeader>
          <CCardBody>
            <div v-for='exam, i in pastExamList' :key='i'>
              <div v-if='exam.industry_id == industry_id'>
                <div v-if='exam.sub_title != undefined'>
                  <a target="_blank" :href="exam.link" class="mgr-20">{{ exam.title }} {{dumyPast(exam.sub_title)}}</a><br>
                </div>
                <div v-else>
                  <a target="_blank" :href="exam.link" class="mgr-20">{{dumyPast(exam.title)}}</a><br>
                </div>
              </div>
            </div>
            <p v-if='isPast == false'>
              データがありません
            </p>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import pastExam from '../mixin/pastExam'
import studyText from '../mixin/data'
import { mapGetters } from 'vuex';
export default {
  pastExam,
  studyText,
  data() {
    return {
      isLoading: true,
      industry_id: this.$route.params.id,
      record: {},
      filter_cs: ['industry_id'],
      filter_vs: [this.$route.params.id],
      studyTextList: [],
      pastExamList: [],
      examinations: [],
      page: 1,
      word: "",
      meta: {},
      isPast: false,
      isData: false,
      select_place: "",
      select_type: "",
      industries: {},
      dictPlaces: {},
      sort_column: "id",
      sort_asc: "desc",
      defaultContent: [
        {
            label: "",
            is_answer: false
        },
        {
            label: "",
            is_answer: false
        },
        {
            label: "",
            is_answer: false
        },
        {
            label: "",
            is_answer: false
        },

      ],
      fields: [
        { key: 'id', label: ""},
        { key: 'date', label: "開催日時"},
        { key: 'country', label: "国"},
        { key: 'region', label: "都道府県"},
        { key: 'address', label: "会場"},
        { key: 'announce_date', label: "合格発表日"},
        { key: 'announce_methods', label: "合格発表方法"},
        { key: 'industry_id', label: "試験業種"}
      ],
      region: [
        '',
        '北海道',
        '青森',
        '岩手',
        '宮城',
        '秋田',
        '山形',
        '福島',
        '茨城',
        '栃木',
        '群馬',
        '埼玉',
        '千葉',
        '東京',
        '神奈川',
        '新潟',
        "富山",
        '石川',
        '福井',
        '山梨',
        '長野',
        '岐阜',
        '静岡',
        '愛知',
        '三重',
        '滋賀',
        '京都',
        '大阪',
        '兵庫',
        '奈良',
        '和歌山',
        '鳥取',
        '島根',
        '岡山',
        '広島',
        '山口',
        '徳島',
        '香川',
        '愛媛',
        '高知',
        '福岡',
        '佐賀',
        "長崎",
        '熊本',
        '大分',
        '宮崎',
        '鹿児島',
        '沖縄',
      ],
      industryTypes: [] ,
      options: [],
      places:{},
      beforeText: ''
    }
  },
  methods: {
    dumyPast(text){
      this.isPast = true
      return text
    },
    dumyData(text){
      this.isData = true
      return text
    },
    checkText(text){
      if(text != ''){
        if(text != this.beforeText){
          this.beforeText = text
          return 'first'
        }else{
          return 'second'
        }
      }else{
        return 'normal'
      }
    },
    getPlace(ids){
      var idList = ids.split(',')
      var result = ''
      idList.forEach(id =>{
        if(id != '') {
          result += this.dictPlaces[id]['name'] + ' , '
        }
      })
      return result.slice( 0, -2 )
    },
    sort: function(e) {
      this.sort_column = e.column
      this.sort_asc = (e.asc == true)? "asc" : "desc"
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/examinations?word=" + this.word + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&per_page=10", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.examinations = response.data.examinations
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    paging: function(n) {
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/examinations?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + n + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&per_page=10", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.examinations = response.data.examinations
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    search: function(e, c) {
      this.word = e
      if(c != undefined){
        this.filter_update(c.target.name, e)
      }
      if(e == "-") {
        this.word = ""
      }
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/examinations?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&per_page=10", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.examinations = response.data.examinations
          this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    formatDate: function(d) {
      var dat = moment(d)
      if(dat.isValid()) {
        return moment(d).tz('Asia/Tokyo').format("YYYY年MM月DD日 HH:mm")
      } else {
        return d
      }
    },

    filter_update: function(k, v) {
      if(this.filter_cs.includes(k)) {
        var i = this.filter_cs.indexOf(k)
        if(v == "-") {
          this.filter_cs.splice(i, 1)
          this.filter_vs.splice(i, 1)
        } else {
          this.filter_cs[i] = k
          this.filter_vs[i] = v
        }
      } else {
        this.filter_cs.push(k)
        this.filter_vs.push(v)
      }
    },
    updatePageData: function(n, e) {
      this.page = n
      console.log(e)
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/examinations?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") +"&page=" + n + "&word=" + this.word + "&column=" + this.sort_column + "&direction=" + this.sort_asc + "&per_page=10", {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.examinations = response.data.examinations
          this.meta = response.data.meta
        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else {
          return d
        }
    },
  },
  mounted() {
    axios
    .get(process.env.VUE_APP_API_ENDPOINT + "/examinations?filter_columns=industry_id&filter_values=" + this.industry_id + "&per_page=10&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.examinations = response.data.examinations
          this.meta = response.data.meta
      }).catch(error => {
          this.errorNotify(error.response)
      })

     axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/place_all", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          console.log('radfsad',response.data)
          this.places = response.data.format_place
          this.dictPlaces = response.data.dict
      }).catch(error => {
          this.errorNotify(error.response)
      })

      axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          response.data.industries.forEach((i) => {
            this.industries[i.id] = i.name
          })
          this.industries = Object.assign({}, this.industries)
      }).catch(error => {
          console.log(error)
      })

      axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/learning_texts?filter_columns=industry_id&filter_values=" + this.industry_id + "&per_page=30&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.studyTextList = response.data.learning_texts
      }).catch(error => {
          console.log(error)
      })

      axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/past_exam_industry?industry_id=" + this.industry_id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          console.log('this is past_exam',response.data)
          this.pastExamList = response.data.past_exam
          this.isLoading = false
      }).catch(error => {
          console.log(error)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
  watch: {
    '$route': function () {
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    }
  }
}
</script>

<style scoped lang="scss">
.answer-form {
  padding: 5px 0px;
}

</style>

